import React from "react";
import "./reviewers.css";

export default function Reviewers() {
  const executiveEditors = [
    { name: "Dr. R. Ratheesh", qualification: "M.E., PhD", country: "India" },
    {
      name: "Dr. M. Saranya Nair",
      qualification: "M.E., PhD",
      country: "India",
    },
    {
      name: "Dr. V. V. Satyanarayana Tallapragada",
      qualification: "",
      country: "India",
    },
    { name: "Mrs. Nisha, K", qualification: "", country: "India" },
    { name: "Mrs. Maria Venila Y", qualification: "", country: "India" },
    { name: "Mrs. Sindhuja, J", qualification: "", country: "India" },
    { name: "Velagapudi Sreenivas", qualification: "", country: "Singapore" },
    { name: "Mr. Manikandan, G", qualification: "", country: "United Kingdom" },
    { name: "Mr. Althaf Hussain", qualification: "", country: "UAE" },
    { name: "Mrs. Delphin Mary", qualification: "", country: "Sweden" },
  ];

  const nationalScientificBoard = [
    { name: "Velagapudi Sreenivas", country: "Singapore" },
  ];

  return (
    <div className="ijacna-reviewers-page">
      <header className="ijacna-reviewers-header">
        <h1 className="ijacna-reviewers-title">Editorial Board Members</h1>
        <p className="ijacna-reviewers-subtitle">
          Dedicated professionals contributing to the excellence of our journal.
        </p>
      </header>

      <section className="ijacna-reviewers-section">
        <h2 className="ijacna-reviewers-section-title">Executive Editors</h2>
        <div className="ijacna-reviewers-grid">
          {executiveEditors.map((editor, index) => (
            <div key={index} className="ijacna-reviewer-card">
              <div className="ijacna-reviewer-icon">🎓</div>
              <div className="ijacna-reviewer-info">
                <h3 className="ijacna-reviewer-name">{editor.name}</h3>
                {editor.qualification && (
                  <p className="ijacna-reviewer-qualification">
                    {editor.qualification}
                  </p>
                )}
                <p className="ijacna-reviewer-country">{editor.country}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ijacna-reviewers-section">
        <h2 className="ijacna-reviewers-section-title">
          National Scientific Board Members
        </h2>
        <div className="ijacna-reviewers-grid">
          {nationalScientificBoard.map((member, index) => (
            <div key={index} className="ijacna-reviewer-card">
              <div className="ijacna-reviewer-icon">🌍</div>
              <div className="ijacna-reviewer-info">
                <h3 className="ijacna-reviewer-name">{member.name}</h3>
                <p className="ijacna-reviewer-country">{member.country}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
